import { observer } from 'mobx-react-lite'
import { AssignNumberCommon } from 'entities/Phone'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'

export const AssignNumber = observer(() => {
  const { addTollFreeNumberStore } = useTollFreeStepsContext()

  return <AssignNumberCommon store={addTollFreeNumberStore.assignNumberStore} />
})
